export default __webpack_public_path__ + "images/vi-bad0002a368d6bca0956ab2b5b889145.svg";